
import { useState, useCallback } from 'react';
import { useToast } from '@/components/ui/use-toast';

export function useFileUpload() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { toast } = useToast();

  const handleFileChange = useCallback((file: File | null) => {
    if (file) {
      // Only validate file size (max 50MB)
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        toast({
          title: "File too large",
          description: "File size must be less than 50MB",
          variant: "destructive",
        });
        return;
      }
      
      console.log("File selected:", file.name);
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  }, [toast]);

  return {
    selectedFile,
    handleFileChange
  };
}
